import React, { useEffect, useState, useRef } from 'react';
import { ELSI_WEBSOCKET_URL, errorCallback, makeUrl, succesCallbackEmpty, handleGetImageUrl, EMPTY_IMAGE_SRC } from '../const/const';
import { getFetchRequest, MAKE_ORDER_REQUEST, postFetchRequest } from '../store/requests';
import { ErrorHandler } from './sharedComponents/ErrorHandler';
import ModalItem from './Modal';
import { ChevronIcon } from '../appearance/icons/chevron_icon';
import { handleTransformDate } from './sharedComponents/helper';
import { PricesList } from './sharedComponents/ProductItem';
import { useNavigate } from 'react-router-dom';

const ChevronIconNavigation = ({ nameOfClass }) => (
    <svg className={nameOfClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.37 12" width="8" height="16">
        <g id="a"></g>
        <g id="b">
            <g id="c">
                <path className="d" d="M6.23,5.52L.85,.15C.66-.05,.34-.05,.15,.15S-.05,.66,.15,.85L5.29,6,.15,11.15c-.2,.2-.2,.51,0,.71,.1,.1,.23,.15,.35,.15s.26-.05,.35-.15L6.23,6.48c.13-.13,.17-.31,.12-.48,.04-.17,0-.35-.12-.48Z"></path>
            </g>
        </g>
    </svg>
);

const modalContent = 'После формирования счета ваш заказ переходит в статус "В работе", в него нельзя будет добавить новые продукты.';

const LIST_OF_STATUSES = {
    CREATED: 'Создан',
    PLACED: 'В работе',
    CANCELLED: 'Отменен',
    PAID: 'Оплачено',
    DONE: 'Завершен',
    AWAITING_PAYMENT: 'Ожидает оплаты',
    PARTIALLY_PLACED: 'Частично размещен',
    SUPPLIER_PLACED: 'Размещен',
};

const paymentAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return 0;
    if (typeof amount === 'number') return amount;
    const parsed = parseFloat(String(amount).replace(/\s/g, '').replace(',', '.'));
    return Number.isNaN(parsed) ? 0 : parsed;
};

// Функция для форматирования даты в формат дд.мм.гггг
const formatDate = (dateString) => {
    if (!dateString) return '';
    
    try {
        let date;
        
        // Обработка различных форматов дат
        if (dateString.includes('T')) {
            // ISO формат: 2024-06-25T11:45:00Z
            date = new Date(dateString);
        } else if (dateString.includes('/') && dateString.includes('-')) {
            // Странный формат: 25/2024-06-25
            const parts = dateString.split('/');
            if (parts.length === 2) {
                date = new Date(parts[1]);
            }
        } else {
            // Обычный формат
            date = new Date(dateString);
        }
        
        if (isNaN(date.getTime())) {
            return '';
        }
        
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}.${month}.${year}`;
    } catch (error) {
        console.error('Ошибка форматирования даты:', error);
        return '';
    }
};



const handleFindActivePrice = (ordersList, orderIndex, index, value) => {
    let currentData = {minQty: 0};
    let allPricesArray = [];
    if(ordersList[orderIndex].products[index].pricesList) {
        allPricesArray = [...allPricesArray, ...ordersList[orderIndex].products[index].pricesList];
    }
    allPricesArray.map(it => it.minQty<=value&&it.minQty>currentData.minQty? currentData = it:null);
    return currentData;
};

const OrdersTable = ({ ordersList, onDownloadInvoice, onOrderClick }) => {
    if (!ordersList.length) {
        return (
            <div className="orders-table-container ">
                <div className="orders-table-header" style={{ display: 'none' }}>
                    <div className="orders-table-buttons">
                        <button className="orders-button orders-button_primary">Новый заказ</button>
                        <button className="orders-button orders-button_secondary">Архив</button>
                    </div>
                    <div className="orders-table-search">
                        <input type="text" className="orders-search-input" placeholder="Код товара или номер заказа" />
                        <button className="orders-search-button">Найти</button>
                    </div>
                </div>
                <div className='orders-page__empty'>Заказов пока нет</div>
            </div>
        );
    }

    return (
        <div className="orders-table-container all-orders">
            <div className="orders-table-header" style={{ display: 'none' }}>
                <div className="orders-table-buttons">
                    <button className="orders-button orders-button_primary">Новый заказ</button>
                    <button className="orders-button orders-button_secondary">Архив</button>
                </div>
                <div className="orders-table-search">
                    <input type="text" className="orders-search-input" placeholder="Код товара или номер заказа" />
                    <button className="orders-search-button">Найти</button>
                </div>
            </div>
            <table className="orders__table orders-table-modern">
                <thead>
                    <tr className="table-header">
                        <th className="table-header__item">Номер</th>
                        <th className="table-header__item">Дата</th>
                        <th className="table-header__item">Счет</th>
                        <th className="table-header__item">Товары</th>
                        <th className="table-header__item">Сумма</th>
                        <th className="table-header__item">Дата оплаты</th>
                        <th className="table-header__item">Состояние</th>
                        <th className="table-header__item">Способ доставки</th>
                    </tr>
                </thead>
                <tbody>
                    {ordersList.map(it => {
                        return (
                            <tr key={it.id} className="table-row table-row-clickable" onClick={() => onOrderClick && onOrderClick(it)}>
                                <td className={`table__item ${it.id?'table__item_active':''}`}>{it.orderNumber}</td>
                                <td className={`table__item table__item-date ${it.dateCreation?'table__item_active':''}`}>{formatDate(it.dateCreation)}</td>
                                <td className={`table__item`}>
                                    <button className="table-link-button" onClick={(e) => {
                                        e.stopPropagation();
                                        onDownloadInvoice && onDownloadInvoice(e, it.id);
                                    }}>
                                        <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6663 1H1V24.11H16.9995V6.33309L11.6663 1Z" stroke="#E7E7E7"/>
                                            <path d="M16.9992 6.33309H11.666V1V6.33309" stroke="#E7E7E7"/>
                                            <path d="M3.66602 9.88867H14.3324" stroke="#E7E7E7"/>
                                            <path d="M3.66602 13.4438H14.3324" stroke="#E7E7E7"/>
                                            <path d="M3.66602 16.999H14.3324" stroke="#E7E7E7"/>
                                            <path d="M3.66602 20.5547H10.7769" stroke="#E7E7E7"/>
                                        </svg>
                                    </button>
                                </td>
                                <td className={`table__item`}>{it.products ? it.products.length : 0}</td>
                                <td className={`table__item ${it.totalCost?'table__item_active':''}`}>{it.totalCost} {it.currency === 'USD' ? '$' : '₽'}</td>
                                <td className={`table__item table__item-date ${(it.paymentDate || it.datePaid)?'table__item_active':''}`}>{formatDate(it.paymentDate || it.datePaid)}</td>
                                <td className={`table__item ${it.status?'table__item_active':''}`}>{LIST_OF_STATUSES[it.status]}</td>
                                <td className={`table__item ${it.deliveryMethod?'table__item_active':''}`}>{it.deliveryMethod || 'Не указан'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="orders-pagination">
                <div className="orders-pagination-controls">
                    <button className="orders-pagination-btn orders-pagination-prev">
                        <ChevronIconNavigation nameOfClass="orders-pagination-icon orders-pagination-icon_prev" />
                    </button>
                    <button className="orders-pagination-btn orders-pagination-btn_active">1</button>
                    <button className="orders-pagination-btn">2</button>
                    <button className="orders-pagination-btn orders-pagination-next">
                        <ChevronIconNavigation nameOfClass="orders-pagination-icon orders-pagination-icon_next" />
                    </button>
                </div>
                <div className="orders-pagination-info">
                    <select className="orders-pagination-select">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                    </select>
                    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5.5 6L10 1" stroke="#1C1C1C"/>
                    </svg>

                </div>
            </div>
        </div>
    );
};

const makeWsRequests = (ws, array) => {
    for(let i=0; i<array.length; i++) {
        for(let j=0; j<array[i].products.length; j++) {
            ws.current.send(JSON.stringify({
                event: "/product/price",
                productId: array[i].products[j].productId,
                productPartNumber: array[i].products[j].productName,
            }));
        }
    }  
};

// Компонент для детального вида заказа
const OrderDetail = ({ order, onBack, onChangeQuantity, onInvoicePrint, onInvoiceDownload }) => {
    if (!order) return null;

    // 🔧 Логируем структуру заказа для отладки цен
    console.log(`📋 [ORDER DETAIL] Order structure:`, {
        orderId: order.id,
        status: order.status,
        totalCost: order.totalCost,
        productsCount: order.products?.length || 0,
    });
    
    if (order.products && order.products.length > 0) {
        order.products.forEach((product, index) => {
            console.log(`📦 [ORDER PRODUCT ${index}] Structure:`, {
                productName: product.productName,
                productCount: product.productCount,
                productPrice: product.productPrice,  // ← Правильное поле с backend
                unitPrice: product.unitPrice,        // ← Неправильное поле (undefined)
                allFields: Object.keys(product),
                fullProduct: product,
            });
        });
    }

    const moneySign = order.currency === 'USD' ? '$' : '₽';

    return (
        <div className="order-detail-container">
            <div className="order-detail-header">
                <button className="order-detail-back-btn" onClick={onBack}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 15L14.5 1M1 1L14.5 15" stroke="#1C1C1C"/>
                    </svg>
                </button>
            </div>
            
            <div className="order-detail-info">
                <h2>Всего {order.products ? order.products.length : 0} товара на сумму:</h2>
                <div className="order-detail-total">
                    {order.totalCost} {moneySign}
                </div>
                
                <div className="order-detail-meta">
                    <div className="order-detail-field">
                        <span className="order-detail-label">Заказ №:</span>
                        <span className="order-detail-value">{order.orderNumber}</span>
                    </div>
                    <div className="order-detail-field">
                        <span className="order-detail-label">Покупатель:</span>
                        <span className="order-detail-value">{order.buyerName || order.customerName || '—'}</span>
                    </div>
                    <div className="order-detail-field">
                        <span className="order-detail-label">Способ получения:</span>
                        <span className="order-detail-value">{order.deliveryMethod}</span>
                    </div>
                    <div className="order-detail-field">
                        <span className="order-detail-label">Получатель:</span>
                        <span className="order-detail-value">{order.recipientName || '—'}</span>
                    </div>
                    <div className="order-detail-field">
                        <span className="order-detail-label">Контактный телефон:</span>
                        <span className="order-detail-value">{order.recipientPhone || '—'}</span>
                    </div>
                    <div className="order-detail-field">
                        <span className="order-detail-label">Адрес доставки:</span>
                        <span className="order-detail-value">{order.deliveryAddress || '—'}</span>
                    </div>
                    <div className="order-detail-status-content order-detail-status-content_mobile">
                        Статус заказа: {LIST_OF_STATUSES[order.status]}
                    </div>
                </div>
            </div>

            <div className="order-detail-products">
                <div className="order-detail-products-layout">
                    <div className="order-detail-received-container">
                        <div className="order-detail-status order-detail-status_received">
                            <div className="order-detail-status-content order-detail-status-content_desktop">
                                Статус заказа: {LIST_OF_STATUSES[order.status]}
                            </div>
                            <div className="order-detail-status-buttons">
                                <button className="order-detail-status-btn" onClick={() => onInvoicePrint && onInvoicePrint(order.id)}>
                                    <svg width="15" height="20" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.6663 1H1V24.11H16.9995V6.33309L11.6663 1Z" stroke="#1C1C1C"/>
                                        <path d="M16.9992 6.33309H11.666V1V6.33309" stroke="#1C1C1C"/>
                                        <path d="M3.66602 9.88867H14.3324" stroke="#1C1C1C"/>
                                        <path d="M3.66602 13.4438H14.3324" stroke="#1C1C1C"/>
                                        <path d="M3.66602 16.999H14.3324" stroke="#1C1C1C"/>
                                        <path d="M3.66602 20.5547H10.7769" stroke="#1C1C1C"/>
                                    </svg>
                                    Распечатать
                                </button>
                                <button className="order-detail-status-btn" onClick={() => onInvoiceDownload && onInvoiceDownload(order.id)}>
                                    <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path className="st0" d="M488.626,164.239c-7.794-7.813-18.666-12.684-30.578-12.676H409.01V77.861L331.145,0h-4.225H102.99v151.564 H53.955c-11.923-0.008-22.802,4.862-30.597,12.676c-7.806,7.798-12.665,18.671-12.657,30.574v170.937 c-0.008,11.919,4.847,22.806,12.661,30.589c7.794,7.813,18.678,12.669,30.593,12.661h49.034V512h306.02V409.001h49.037 c11.901,0.008,22.78-4.848,30.574-12.661c7.818-7.784,12.684-18.67,12.677-30.589V194.814 C501.306,182.91,496.436,172.038,488.626,164.239z M323.519,21.224l62.326,62.326h-62.326V21.224z M123.392,20.398l179.725,0.015 v83.542h85.491v47.609H123.392V20.398z M388.608,491.602H123.392v-92.801h-0.016v-96.638h265.217v106.838h0.015V491.602z M480.896,365.751c-0.004,6.353-2.546,11.996-6.694,16.17c-4.166,4.136-9.813,6.667-16.155,6.682h-49.049V281.75H102.974v106.853 H53.955c-6.365-0.015-12.007-2.546-16.166-6.682c-4.144-4.174-6.682-9.817-6.686-16.17V194.814 c0.004-6.338,2.538-11.988,6.686-16.155c4.167-4.144,9.809-6.682,16.166-6.698h49.034h306.02h49.037 c6.331,0.016,11.985,2.546,16.151,6.698c4.156,4.174,6.694,9.817,6.698,16.155V365.751z" fill="#1C1C1C"></path>
                                            <rect x="167.59" y="336.155" className="st0" width="176.82" height="20.405" fill="#1C1C1C"></rect>
                                            <rect x="167.59" y="388.618" className="st0" width="176.82" height="20.398" fill="#1C1C1C"></rect>
                                            <rect x="167.59" y="435.255" className="st0" width="83.556" height="20.398" fill="#1C1C1C"></rect>
                                            <path className="st0" d="M353.041,213.369c-9.263,0-16.767,7.508-16.767,16.774c0,9.251,7.504,16.759,16.767,16.759 c9.263,0,16.77-7.508,16.77-16.759C369.811,220.877,362.305,213.369,353.041,213.369z" fill="#1C1C1C"></path>
                                            <path className="st0" d="M424.427,213.369c-9.262,0-16.77,7.508-16.77,16.774c0,9.251,7.508,16.759,16.77,16.759 c9.258,0,16.766-7.508,16.766-16.759C441.193,220.877,433.685,213.369,424.427,213.369z" fill="#1C1C1C"></path>
                                        </g>
                                    </svg>
                                    Скачать
                                </button>
                            </div>
                        </div>
                        <table className="order-detail-table order-detail-table_received">
                            <thead>
                                <tr>
                                    <th>№</th>
                                    <th>Наименование товара / Производитель</th>
                                    <th>Отгрузка</th>
                                    <th>Кол-во</th>
                                    <th>Цена</th>
                                    <th>Всего</th>
                                </tr>
                            </thead>
                            <tbody>
                                {order.products && order.products.map((product, index) => (
                                    <tr key={product.productId}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <div className="product-info-row">
                                                <div className="product-details">
                                                    <div className="product-name">
                                                        {product.manufacturerName ? 
                                                            `${product.productName} (${product.manufacturerName})` : 
                                                            product.productName}
                                                    </div>
                                                </div>
                                                {product.productImage ? (
                                                    <div className="product-image">
                                                        <img 
                                                            src={handleGetImageUrl(product.productId, product.productImage)} 
                                                            alt={product.productName}
                                                            onError={(e) => { e.target.onerror = null; e.target.src = EMPTY_IMAGE_SRC; }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="product-image product-image-placeholder">
                                                        <svg viewBox="0 0 60 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="60" height="50" fill="#f0f0f0"/>
                                                            <path d="M20 20h20v10h-20z" fill="#d0d0d0"/>
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="received-shipment">
                                                <div className="received-shipment-value">
                                                    {product.availableStock > 50 ? 'Склад' : '20-30 раб. дней'}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="received-quantity">
                                                <div className="received-quantity-value">{product.productCount} шт.</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="received-price">
                                                <div className="received-price-value">{product.productPrice ? parseFloat(product.productPrice).toFixed(2) : '0.00'} {moneySign}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="received-total">
                                                <div className="received-total-value">{((parseFloat(product.productPrice) || 0) * product.productCount).toFixed(2)} {moneySign}</div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="order-total-sidebar order-total-sidebar_received">
                        <div className="order-detail-payments">
                            <div className="order-total-header">Оплаты по заказу</div>
                            <table className="orders__table orders-table-modern">
                                <thead>
                                    <tr className="table-header">
                                        <th className="table-header__item">№</th>
                                        <th className="table-header__item">Номер п/п</th>
                                        <th className="table-header__item">Дата поступления оплаты</th>
                                        <th className="table-header__item">Сумма, ₽</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.payments && order.payments.length > 0 ? order.payments.map((payment, paymentIndex) => (
                                        <tr key={payment.documentNumber || payment.id || paymentIndex} className="table-row">
                                            <td className="table__item table__item_active">{paymentIndex + 1}</td>
                                            <td className="table__item table__item_active">{payment.number || payment.documentNumber || '-'}</td>
                                            <td className="table__item table__item_active">{formatDate(payment.date || payment.paymentDate)}</td>
                                            <td className="table__item table__item_active">{paymentAmount(payment.amount).toFixed(2)}</td>
                                        </tr>
                                    )) : (
                                        <tr className="table-row">
                                            <td className="table__item table__item_active">-</td>
                                            <td className="table__item table__item_active">-</td>
                                            <td className="table__item table__item_active">-</td>
                                            <td className="table__item table__item_active">-</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="order-total-final">
                                Общая сумма оплат, ₽: {order.payments && order.payments.length > 0 
                                    ? order.payments.reduce((sum, payment) => sum + paymentAmount(payment.amount), 0).toFixed(2)
                                    : '0.00'}
                            </div>
                        </div>
                        
                        <div className="order-detail-shipments">
                            <div className="order-total-header">Отгрузки по заказу</div>
                            <table className="orders__table orders-table-modern">
                                <thead>
                                    <tr className="table-header">
                                        <th className="table-header__item">№</th>
                                        <th className="table-header__item">УТД (фактура)</th>
                                        <th className="table-header__item">Дата</th>
                                        <th className="table-header__item">Сумма с НДС, ₽</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.shipments && order.shipments.length > 0 ? order.shipments.map((shipment) => (
                                        <tr key={shipment.id} className="table-row">
                                            <td className="table__item table__item_active">{shipment.id}</td>
                                            <td className="table__item table__item_active">{shipment.invoice}</td>
                                            <td className="table__item table__item_active">{shipment.date}</td>
                                            <td className="table__item table__item_active">{shipment.amount}</td>
                                        </tr>
                                    )) : (
                                        <tr className="table-row">
                                            <td className="table__item table__item_active">-</td>
                                            <td className="table__item table__item_active">-</td>   
                                            <td className="table__item table__item_active">-</td>
                                            <td className="table__item table__item_active">-</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="order-total-final">
                                Общая сумма отгруженного товара, ₽: {order.shipments && order.shipments.length > 0 
                                    ? order.shipments.reduce((sum, shipment) => sum + parseFloat(shipment.amount.replace(' ', '')), 0).toFixed(2)
                                    : '0.00'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const OrdersPage = ({ isCollapsed, mainPage=null }) => {
    const [ordersList, setOrdersList] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentOrderId, setCurrentOrderId] = useState('');
    const [productsListIsOpen, setProductsListIsOpen] = useState(false);
    const [activePricesIsChanged, setActivePricesIsChanged] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const ws = useRef();
    const navigate = useNavigate();

    const gettingData = (array) => {
        if (!ws.current) return;

        ws.current.onmessage = e => {
            try {
                const message = JSON.parse(e.data);
                if(message && message.length) {
                    array.forEach(it => {
                        for(let i = 0; i<it.products.length; i++) {
                            if(it.products[i].productId === message[0].productId) {
                                it.products[i].pricesList = message;
                            }
                        }
                    });
                    setOrdersList([...array]);
                }
            } catch (err) {
                console.log(err);
            }
        };
    };
    
    const getProductPriceData = (array) => {
        if(!ws.current) {
            ws.current = new WebSocket(`${ELSI_WEBSOCKET_URL}/ws/v1?token=${localStorage.getItem('token')}`);
            ws.current.onopen = () => {
                makeWsRequests(ws, array);
            };
        } else {
            makeWsRequests(ws, array);
        }
        gettingData(array);

    };

    const succesGetOrderCallback = (result) => {
        const placedOrders = (Array.isArray(result) ? result : []).filter((order) => order?.status !== 'CREATED');
        if(placedOrders.length) {
            if(mainPage) {
                setOrdersList(placedOrders.slice(0, 6));
            } else {
                setOrdersList(placedOrders);
                getProductPriceData(placedOrders);
            }
        } else {
            // Если нет данных с бэкенда, устанавливаем пустой массив
            setOrdersList([]);
        }
    };

    const errorCallbackWithLogging = (error) => {
        console.log('Ошибка загрузки заказов:', error);
        // В случае ошибки устанавливаем пустой массив
        setOrdersList([]);
        // Вызываем оригинальный обработчик ошибок
        errorCallback(error);
    };

    useEffect(() => {
        getFetchRequest(makeUrl([MAKE_ORDER_REQUEST]), succesGetOrderCallback, errorCallbackWithLogging);
        return () => {
            ws.current&&ws.current.close();
            ws.current = null;
        };
    },[]);

    const successGetDataCallback = async (response, orderId) => {
        const blob = await response.blob();
        const newBlob = new Blob([blob]);
        const url = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `${orderId}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setCurrentOrderId('');
        setModalIsOpen(false);
        getFetchRequest(makeUrl([MAKE_ORDER_REQUEST]), succesGetOrderCallback, errorCallback);
    };

    const handleGetOrderData = () => {
        getFetchRequest(makeUrl([MAKE_ORDER_REQUEST, currentOrderId, '/invoice/']), (response) => successGetDataCallback(response, currentOrderId), errorCallback, true);
    };

    const downloadInvoicePdf = async (orderId, shouldPrint = false) => {
        if (!orderId) return;
        try {
            const url = makeUrl([MAKE_ORDER_REQUEST, orderId, '/invoice/pdf/']);
            const response = await fetch(url, { method: 'GET', credentials: 'include' });
            if (!response.ok) {
                throw new Error('Invoice not ready');
            }
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            if (shouldPrint) {
                const printWindow = window.open(blobUrl);
                if (printWindow) {
                    printWindow.onload = () => {
                        printWindow.focus();
                        printWindow.print();
                    };
                }
            } else {
                const link = document.createElement('a');
                link.href = blobUrl;
                link.setAttribute('download', `invoice-${orderId}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
        } catch (e) {
            alert('Счет пока недоступен. Попробуйте позже.');
        }
    };

    const handlePrintInvoice = (orderId) => downloadInvoicePdf(orderId, true);
    const handleDownloadInvoice = (orderId) => downloadInvoicePdf(orderId, false);

    const handleOpenModal = (e, id) => {
        e.stopPropagation();
        setCurrentOrderId(id);
        setModalIsOpen(true);
    };

    const handleCloseModal = (e) => {
        e.stopPropagation();
        setModalIsOpen(false);
    };

    const handleChangeQuantity = (step, index, orderIndex, value=null) => {
        if( ordersList[orderIndex].products[index].productCount === 0 && step === -1) {
            return;
        }
        const coppiedData = [...ordersList];
        let newQuantityValue;
        if(step !== 0 ) {
            newQuantityValue = ordersList[orderIndex].products[index].productCount+step;
        } else {
            newQuantityValue = value;
        }
        coppiedData[orderIndex].products[index].productCount = newQuantityValue;
        const data = {
            stockId: coppiedData[orderIndex].products[index].stockId,
            productCount: newQuantityValue,
        };
        postFetchRequest(makeUrl([MAKE_ORDER_REQUEST, coppiedData[orderIndex].id, '/product/', ordersList[orderIndex].products[index].productId, '/']), 
            data, succesCallbackEmpty, errorCallback, true);
        setOrdersList([...coppiedData]);
        setActivePricesIsChanged(prev => !prev);
    };

    // Функция для обработки клика на заказ
    const handleOrderClick = (order) => {
        setSelectedOrder(order);
    };

    // Функция для возврата к списку заказов
    const handleBackToOrders = () => {
        setSelectedOrder(null);
    };

    try {
        return (
            <section className={`workspace workspace_align orders-page ${isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'}`}
                onClick={(e) => handleCloseModal(e)}>
                <nav className="navigation-block container">
                    <div className="navigation-group">
                        <a href="#" className="navigation-item navigation-goback" onClick={e => { e.preventDefault(); navigate(-1); }}>Назад</a>
                        <ChevronIconNavigation nameOfClass="navigation-icon__separate" />
                        <a href="#" className="navigation-item" onClick={e => { e.preventDefault(); navigate('/home'); }}>Главная</a>
                        <ChevronIconNavigation nameOfClass="navigation-icon__separate" />
                        <a className="navigation-item navigation-item_current" href="#">Заказы</a>
                        {selectedOrder && (
                            <>
                                <ChevronIconNavigation nameOfClass="navigation-icon__separate" />
                                <a className="navigation-item navigation-item_current" href="#">{selectedOrder.orderNumber}</a>
                            </>
                        )}
                    </div>
                </nav>
                {modalIsOpen ? <ModalItem handleClose={() => setModalIsOpen(false)} handleLoad={handleGetOrderData} content={modalContent} /> : ''}
                
                {selectedOrder ? (
                    <OrderDetail 
                        order={selectedOrder} 
                        onBack={handleBackToOrders}
                        onChangeQuantity={handleChangeQuantity}
                        onInvoicePrint={handlePrintInvoice}
                        onInvoiceDownload={handleDownloadInvoice}
                    />
                ) : (
                    <OrdersTable 
                        ordersList={ordersList} 
                        onDownloadInvoice={handleOpenModal} 
                        onOrderClick={handleOrderClick} 
                    />
                )}
            </section>
        );
    } catch (error) {
        return <ErrorHandler />;
    }
};

export default OrdersPage;
